<template>
    <div>
        <div class="mcc-page-header">
            <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
                <div class="mcc-row">

                    <section class="mcc-col mu-d-flex mu-flex-row">
                        <h1 class="mu-mb-00">Applications </h1>
                        <details class="mcc-popover mcc-popover--bottom-end">
                            <summary class="mcc-button mcc-button--icon-only ">
                                <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                            </summary>
                            <div class="mcc-popover__content">

                                <p class="mu-mb-00">
                                    {{ helpText.title }}
                                    <a :href="helpText.url" target="_blank">Read more...</a>
                                </p>
                            </div>
                        </details>

                    </section>
                    <section class="mcc-col mu-d-flex mu-justify-content-end mu-align-items-center">
                        <div role="group" class="mcc-button-group">
                            <router-link :to="CONTEXT_PATH + '/design/applications/new'">
                                <button class="mcc-button mcc-button--primary" id="addApplicationBtn"
                                    title="Add application">
                                    <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span
                                        class="mcc-button__label">Add application</span>
                                </button>
                            </router-link>

                        </div>

                    </section>
                </div>

            </div>
        </div>
        <div class="mcc-container--fluid card-padding">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Design</li>
                    <li>Applications</li>

                </ol>
            </nav>

            <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="filterTable"
                title="Application Filters">

                <section class="mcc-card mu-border-0">
                    <div class="mcc-row" v-show="!dataCall">
                        <div>
                            <form id="formIdd">
                                <div>
                                    <div class="mfc-input-wrapper mfc-form-input-container mu-mb-03">
                                        <label for="name">Name</label>
                                        <input type="text" name="application-name" maxlength="50" id="name"
                                            :pattern="nameRegex" :value="applicationNameRef"
                                            @change="applicationNameRef = $event.target.value">

                                    </div>

                                    <div class="mfc-slim-select-wrapper mu-mb-03">
                                        <label for="slim-select_multiple">Tags</label>
                                        <select id="slim-select_multiple" class="mfc-slim-select"
                                            aria-label="multiple_radio_input"
                                            @change="selectedLabelRef = $event.target.value" multiple>
                                            <option v-for="label in applications"
                                                :selected="selectedLabelRef.indexOf(label) > -1" :key="label"
                                                :value="label">{{ label }}</option>
                                        </select>
                                    </div>
                                    <div class="mt-2">
                                        <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                            <fieldset class="mfc-fieldset">
                                                <legend class="mfc-label">
                                                    Deployed
                                                </legend>
                                                <div class="mcc-segmented-buttons__list" ref="radioRef"
                                                    name="deployed-radioGroup" id="deployed-radioGroup">
                                                    <input id="Deployed_button1" name="Deployed-choice-button-group"
                                                        type="radio" value="yes"
                                                        @click="deployedRef = $event.target.value"
                                                        :checked="deployedRef == 'yes'">
                                                    <label class="mcc-segmented-buttons__button" for="Deployed_button1">
                                                        <span class="mcc-segmented-buttons__label">Yes</span>
                                                    </label>
                                                    <input id="Deployed_button2" name="Deployed-choice-button-group"
                                                        type="radio" value="no"
                                                        @click="deployedRef = $event.target.value"
                                                        :checked="deployedRef == 'no'">
                                                    <label class="mcc-segmented-buttons__button" for="Deployed_button2">
                                                        <span class="mcc-segmented-buttons__label">No</span>
                                                    </label>
                                                    <input id="Deployed_button3" name="Deployed-choice-button-group"
                                                        type="radio" value="all"
                                                        @click="deployedRef = $event.target.value"
                                                        :checked="deployedRef == 'all'">
                                                    <label class="mcc-segmented-buttons__button" for="Deployed_button3">
                                                        <span class="mcc-segmented-buttons__label">All</span>
                                                    </label>

                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                            <fieldset class="mfc-fieldset">
                                                <legend class="mfc-label">
                                                    Disabled
                                                </legend>
                                                <div class="mcc-segmented-buttons__list" ref="disabledRadioRef"
                                                    name="disabled-radioGroup" id="disabled-radioGroup">
                                                    <input id="Disabled_button1" name="Disabled-choice-button-group"
                                                        type="radio" value="yes"
                                                        @click="disabledRef = $event.target.value"
                                                        :checked="disabledRef == 'yes'">
                                                    <label class="mcc-segmented-buttons__button" for="Disabled_button1">
                                                        <span class="mcc-segmented-buttons__label">Yes</span>
                                                    </label>
                                                    <input id="Disabled_button2" name="Disabled-choice-button-group"
                                                        type="radio" value="no"
                                                        @click="disabledRef = $event.target.value"
                                                        :checked="disabledRef == 'no'">
                                                    <label class="mcc-segmented-buttons__button" for="Disabled_button2">
                                                        <span class="mcc-segmented-buttons__label">No</span>
                                                    </label>
                                                    <input id="Disabled_button3" name="Disabled-choice-button-group"
                                                        type="radio" value="all"
                                                        @click="disabledRef = $event.target.value"
                                                        :checked="disabledRef == 'all'">
                                                    <label class="mcc-segmented-buttons__button" for="Disabled_button3">
                                                        <span class="mcc-segmented-buttons__label">All</span>
                                                    </label>

                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                            <fieldset class="mfc-fieldset">
                                                <legend class="mfc-label">
                                                    Protected
                                                </legend>
                                                <div class="mcc-segmented-buttons__list" ref="protectedRadioRef"
                                                    name="protected-radioGroup" id="protected-radioGroup">
                                                    <input id="Protected_button1" name="Protected-choice-button-group"
                                                        type="radio" value="yes"
                                                        @click="protectedRef = $event.target.value"
                                                        :checked="protectedRef == 'yes'">
                                                    <label class="mcc-segmented-buttons__button"
                                                        for="Protected_button1">
                                                        <span class="mcc-segmented-buttons__label">Yes</span>
                                                    </label>
                                                    <input id="Protected_button2" name="Protected-choice-button-group"
                                                        type="radio" value="no"
                                                        @click="protectedRef = $event.target.value"
                                                        :checked="protectedRef == 'no'">
                                                    <label class="mcc-segmented-buttons__button"
                                                        for="Protected_button2">
                                                        <span class="mcc-segmented-buttons__label">No</span>
                                                    </label>
                                                    <input id="Protected_button3" name="Protected-choice-button-group"
                                                        type="radio" value="all"
                                                        @click="protectedRef = $event.target.value"
                                                        :checked="protectedRef == 'all'">
                                                    <label class="mcc-segmented-buttons__button"
                                                        for="Protected_button3">
                                                        <span class="mcc-segmented-buttons__label">All</span>
                                                    </label>

                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </div>

                    </div>
                </section>

            </Drawer>

            <AssignComponent ref="AssignDrawer" @reset-filter="resetFilter" @assign="AssignApplication" :loading="assignmentLoading" :can-submit="canSubmit"
                title="Application Access">

                <section class="mcc-card mu-border-0">
                    
                    <div class="mcc-row" v-show="!dataCall">
                        <div>
                            <form id="formIdd">         
                                <div v-show="!assignmentLoading">
                                    <div class="mfc-input-wrapper mfc-form-input-container mu-mb-07">
                                        <label for="applicationName"
                                            style="font-weight: bold; color: #000;">Application</label>
                                        <input type="text" id="applicationName" :value="selectedApplicationName"
                                            readonly />
                                    </div>
                                    <div class="mfc-input-wrapper mfc-form-input-container mu-mb-05">
                                        <span style="font-weight: bold;">Send template</span>
                                        <label class="text-muted">Send a flow template to a customer</label>
                                    </div>

                                    <div class="mfc-slim-select-wrapper mu-mb-03">
                                        <label for="customer-org-select" style="font-weight: bold;  color: #000;">Select
                                            customer organisation</label>
                                        <select id="customer-org-select" class="mfc-slim-select"
                                            aria-label="multiple_radio_input" v-model="selectedCustomerOrg"
                                            @change="onCustomerOrgChange" multiple>
                                            <option v-for="org in unassignedCustomerOrgs" :key="org.id" :value="org.id">
                                                {{ org.name }}</option>
                                        </select>
                                    </div>
                                    <div class="mu-mt-01 mu-mb-06 mu-d-flex mu-align-items-center">
                                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                                        <label class="text-muted" style="font-size: 10px;">Choose who you want to send
                                            this template to</label>
                                    </div>

                                    <div v-if="assignedCustomerOrgs && assignedCustomerOrgs.length > 0" class="mfc-input-wrapper mfc-form-input-container mu-mb-04">
                                        <label for="customer-org-select" style="font-weight: bold; color: #000;">Manage
                                            access</label>
                                        <label class="text-muted">Click to remove access to customers below</label>
                                    </div>
                                    <div class="mcc-row mu-mb-03" v-for="item in assignedCustomerOrgs" :key="item">
                                        <div class="mcc-col">
                                            <div class="my-2">
                                                <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                    <input type="checkbox" :id="item.id" class="mfc-switch"
                                                        v-model="checkboxState[item.id]" @change="onToggle(item)" />
                                                    <label :for="item.id">{{ item.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>

            </AssignComponent>
            <div class="mcc-row">
                <div class="mcc-col">
                    <div class="mcc-card">
                        <div v-if="!updateCall" class="spinner-overlay ">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex ">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                    style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none"
                                        stroke-width="5">
                                    </circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>
                        <div class="mcc-card__body">
                            <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                <button class="mcc-button mcc-button--outline  mcc-button--sm"
                                    @click="$refs.customFilter.open()">
                                    <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                    <span class="mcc-button__label">Filters {{ filterCount > 0 ? ` (${filterCount})` :
                                        '(3)'}}</span>
                                </button>
                            </div>
                            <div>
                                <div>
                                    <div class="mcc-table-toolbar" v-show="selectedApplications.length > 0">
                                        <div class="mcc-table-batch-actions mcc-table-batch-actions--active">
                                            <div class="mcc-table-batch-actions__summary">
                                                <p class="mu-mb-00">{{ selectedApplications.length }} {{
                                                    selectedApplications.length > 1 ? 'rows selected' : 'row selected'}}
                                                </p>
                                            </div>
                                            <div class="mcc-table-batch-actions__list">
                                                <div class="mcc-button-group mcc-button-group--spaced">
                                                    <button class="mcc-button mcc-button mu-border mu-border-ui-01"
                                                        @click="exportApplications()" id="exportApplicationBtn"
                                                        title="Export applications"
                                                        v-show="selectedApplications.length > 0">
                                                        <mcc-icon name="export" aria-hidden="true"></mcc-icon><span
                                                            class="mcc-button__label"></span>
                                                        <label>Export applications</label>
                                                    </button>
                                                    <button id="cancelBtn"
                                                        class="mcc-button mcc-button--icon-only mcc-button--sm mcc-button--primary"
                                                        @click="uncheckAll">
                                                        <mcc-icon name="cancel" aria-hidden="true"></mcc-icon>
                                                        <span class="mcc-button__label">Cancel</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <mcc-data-table ref="applicationTable" id="applicationTableId"></mcc-data-table>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import constantMessages from "../../../messages";
import ApplicationAPI from "../../../services/ApplicationAPI";
import Table from "@advanced/component-mosaic-table";
import ImportExportAPI from "../../../services/ImportExportAPI";
import Utils from "@/script_utils";
import Drawer from "../../common/Drawer.vue";
import { EventBus } from "../../../services/event-bus";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
import AssignComponent from "../../customComponents/AssignComponent.vue";

export default {
    name: "ApplicationHome",
    components: {
        Drawer,
        AssignComponent
    },
    computed: {
        canSubmit() {
            return this.modifiedAssignedCustomerOrgs.length > 0 || this.selectedCustomerOrg.length > 0;
        }
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["application.list"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            nameRegex: constantMessages.PATTERNS["name"],
            searchCriteria: {},
            applications: {},
            selectedLabelRef: "",
            selectedLabels: "",
            applicationName: "",
            deployedType: "all",
            disabledType: "no",
            protectedType: "all",
            applicationNameRef: "",
            deployedRef: "all",
            disabledRef: "no",
            protectedRef: "all",
            selectedForm: [],
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            dataCall: true,
            disableActionArray: [],
            selectedApplications: [],
            responseData: [],
            pageStart: -1,
            filterCount: 0,
            tableData: [],
            filterActive: false,
            filterData: [],
            tagInstance: null,


            // For AssignComponent drawer
            selectedApplicationName: "",
            selectedApplicationId: null,
            assignmentLoading: false,
            selectedCustomerOrg: [],
            allCustomerOrgs: [],
            unassignedCustomerOrgs: [],
            notifyCustomer: false,
            assignedCustomerOrgs: [],
            modifiedAssignedCustomerOrgs: [],
            checkboxState: {} // dynamic state per item 
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        if (localStorage.getItem("application") === "application") {

            let storedAppName = localStorage.getItem("DataTables_" + window.location.pathname + "_applicationName");

            if (storedAppName != null && storedAppName != "") {
                this.applicationNameRef = storedAppName;
                this.applicationName = storedAppName;
            }

            let storedDeploy = localStorage.getItem("DataTables_" + window.location.pathname + "_deployedType");

            if (storedDeploy != null && storedDeploy != "") {
                this.deployedRef = storedDeploy;
                this.deployedType = storedDeploy;
            }

            let storedDisable = localStorage.getItem("DataTables_" + window.location.pathname + "_disabledType");

            if (storedDisable != null && storedDisable != "") {
                this.disabledRef = storedDisable;
                this.disabledType = storedDisable;
            }

            let storedProtect = localStorage.getItem("DataTables_" + window.location.pathname + "_protectedType");

            if (storedProtect != null && storedProtect != "") {
                this.protectedRef = storedProtect;
                this.protectedType = storedProtect;
            }

            let selectedLabelRefString = localStorage.getItem("DataTables_" + window.location.pathname + "_selectedLabels");

            if (selectedLabelRefString != "" && selectedLabelRefString != null) {
                this.selectedLabelRef = selectedLabelRefString.split(",");
                this.selectedLabels = this.selectedLabelRef;
            }

            let storedSize = localStorage.getItem("applicationHomePageSize");
            if (storedSize != null && storedSize != "") {
                this.currentPageSize = parseInt(storedSize);
            }
            localStorage.removeItem("applicationHomePageSize");
            localStorage.removeItem("application");

            localStorage.removeItem("DataTables_" + window.location.pathname + "_applicationName");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_deployedType");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_disabledType");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_protectedType");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_selectedLabels");
            this.filterCount = parseInt(localStorage.getItem("setFilterDataInLocalStorage"));
            localStorage.removeItem("setFilterDataInLocalStorage");
        }
        this.initApplicationsTable();
        this.tagInstance = new SlimSelect({
            select: '#slim-select_multiple',
            settings: {
                closeOnSelect: false,
            },
        });
        this.customerOrgInstance = new SlimSelect({
            select: '#customer-org-select',
            settings: {
                closeOnSelect: false,
            },
        });

        ApplicationAPI.getApplicationLabels()
            .then(result => {
                this.applications = result;
            });

        // Fetch customer organisations for AssignComponent drawer
        ApplicationAPI.getCustomerOrganizations(0, 200)
            .then(result => {
                this.allCustomerOrgs = result.data
                    .filter(item => item.tenancyRef !== this.$store.getters.getOrganisationReferences)
                    .map(item => ({
                        id: item.tenancyRef,
                        name: item.tenancyRef
                    }))
                    .sort((a, b) => a.name.localeCompare(b.name));

                console.log('All Customer Orgs:', this.allCustomerOrgs);
                console.log('All Customer Orgs:', this.$store.getters.getOrganisationReferences);

            })
            .catch(error => {
                console.error('Error fetching customer orgs:', error);
                this.allCustomerOrgs = [];
            })
            .finally(() => {
                // optional cleanup / loader stop
            });

    },
    methods: {
        getFilterCount() {
            if (this.selectedLabelRef != "")
                this.filterCount += 1;
            if (this.applicationNameRef != "")
                this.filterCount += 1;
            if (this.deployedRef != "")
                this.filterCount += 1;
            if (this.disabledRef != "")
                this.filterCount += 1;
            if (this.protectedRef != "")
                this.filterCount += 1;
        },
        filterTable(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;

            }
            this.filterCount = 0;
            this.getFilterCount();
            this.selectedLabeuls = this.tagInstance.getSelected();
            this.applicationName = this.applicationNameRef;
            this.deployedType = this.deployedRef;
            this.disabledType = this.disabledRef;
            this.protectedType = this.protectedRef;
            this.initApplicationsTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },

        async AssignApplication(e) {
            var errorMessageFromAssignOperation = "";
            var messageFromUnassignOperation = "";
            var errorMessageFromUnassignOperation = "";
            let failureMessages = [];
            let successMessages = [];
            let failureMessagesForUnassign = [];
            let successMessagesForUnassign = [];
            this.assignmentLoading = true;
            if (this.selectedCustomerOrg.length > 0) {
                try {
                    const requestPayload = Array.isArray(this.selectedCustomerOrg)
                    ? {
                        targetTenantIds: this.selectedCustomerOrg,
                        newApplicationName: this.selectedApplicationName
                    }
                    : {};
                console.error('Request payload for assign API:', requestPayload);
                const validationResult = await ApplicationAPI.validateAssignOperation(this.selectedApplicationId, requestPayload);
                console.log('Validation successful for assigning application.', validationResult);
                const assignResult = await ApplicationAPI.assignApplicationToCustomerOrganizations(this.selectedApplicationId, requestPayload);        
                const result = this.processAssignmentResponse(assignResult, this.selectedApplicationName);
                failureMessages = result.failureMessages;
                successMessages = result.successMessages;
                console.log('Failures:', failureMessages);
                console.log('Successes:', successMessages);
                } catch (error) {
                        errorMessageFromAssignOperation = error.customMessage ;
                }
            }
            if (this.modifiedAssignedCustomerOrgs.length > 0) {
                try {
                    const requestPayload = Array.isArray(this.modifiedAssignedCustomerOrgs)
                    ? {
                        targetTenantIds: this.modifiedAssignedCustomerOrgs
                    }
                    : {};
                console.error('Request payload for unassign API:', requestPayload);
                const assignResult = await ApplicationAPI.unassignApplicationFromCustomerOrganizations(this.selectedApplicationId, requestPayload);
                const result = this.processUnassignmentResponse(assignResult, this.selectedApplicationName);
                failureMessagesForUnassign = result.failureMessages;
                successMessagesForUnassign = result.successMessages;
                console.log('Failures:', failureMessagesForUnassign);
                console.log('Successes:', successMessagesForUnassign);
                } catch (error) {
                    errorMessageFromUnassignOperation = error.customMessage ;
                }
                
            } 
            this.$refs.AssignDrawer.close();
            this.assignmentLoading = false;

            // Emit a notification for each success message
            if (successMessages && successMessages.length > 0) {
                successMessages.forEach(msg => {
                    EventBus.$emit('success-notification', {
                        "msg": msg
                    });
                });
            }
            // Emit a notification for each failure message
            if (failureMessages && failureMessages.length > 0) {
                failureMessages.forEach(msg => {
                    EventBus.$emit('error-notification', {
                        "msg": msg
                    });
                });
            }
            if (errorMessageFromAssignOperation !== "") {
                EventBus.$emit('error-notification', {
                    "msg": errorMessageFromAssignOperation
                });
            }
             // Emit a notification for each success message
            if (successMessagesForUnassign && successMessagesForUnassign.length > 0) {
                successMessagesForUnassign.forEach(msg => {
                    EventBus.$emit('success-notification', {
                        "msg": msg
                    });
                });
            }
            // Emit a notification for each failure message
            if (failureMessagesForUnassign && failureMessagesForUnassign.length > 0) {
                failureMessagesForUnassign.forEach(msg => {
                    EventBus.$emit('error-notification', {
                        "msg": msg
                    });
                });
            }
            if (errorMessageFromUnassignOperation !== "") {
                EventBus.$emit('error-notification', {
                    "msg": errorMessageFromUnassignOperation
                });
            }
            
             

        },
        processAssignmentResponse(response,appName) { 
        // Failure messages
        const failureMessages = (response.failedAssignments || []).map(failed => {
           return `Application assignment was unsuccessful for the  ${failed.targetTenantId}`;
        });

        // Success messages
        const successMessages = (response.successfulAssignments || []).map(success => {
           return `Application assigned successfully to  ${success.targetTenantId}`;
        });

        return { failureMessages, successMessages };
        },

        processUnassignmentResponse(response,appName) { 
        // Failure messages
        const failureMessages = (response.failedUnassignments || []).map(failed => {
           return `Application unassignment was unsuccessful for the  ${failed.targetTenantId}`;
        });

        // Success messages
        const successMessages = (response.successfulUnassignments || []).map(success => {
           return `Application unassigned successfully from  ${success.targetTenantId}`;
        });

        return { failureMessages, successMessages };
        },
        onToggle(item) {
            if (!this.checkboxState[item.id]) {
                // Add to serverList if not already present
                if (!this.modifiedAssignedCustomerOrgs.some(o => o === item.id)) {
                    this.modifiedAssignedCustomerOrgs.push(item.id);
                }
            } else {
                // Remove from serverList if unchecked
                this.modifiedAssignedCustomerOrgs = this.modifiedAssignedCustomerOrgs.filter(o => o !== item.id);
            }
            console.log("Server List:", this.modifiedAssignedCustomerOrgs);
        },
        uncheckAll() {
            let self = this;
            const selectedList = document.querySelectorAll("#applicationTableId input[type=checkbox]:checked");

            selectedList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            self.selectedApplications = [];
        },
        resetFilter() {
            this.updateCall = false;
            this.filterCount = 0;
            this.deployedRef = "all";
            this.disabledRef = "no";
            this.protectedRef = "all";
            this.protectedType = "all";
            this.selectedLabelRef = "";
            this.tagInstance.setSelected([]);
            this.applicationNameRef = "";
            this.selectedLabels = "";
            this.applicationName = "";
            this.deployedType = "all";
            this.disabledType = "no";
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initApplicationsTable();
        },
        updateTemplate() {
            let self = this;
            // Assign button click
            this.$refs.applicationTable
                .querySelectorAll('td .assign-btn')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        try {
                            self.assignmentLoading = true;
                            self.$refs.AssignDrawer.open();
                            self.selectedApplicationId = e.target.getAttribute("data-id");
                            let appName = e.target.getAttribute("data-name");

                            self.selectedCustomerOrg = [];
                            self.modifiedAssignedCustomerOrgs = [];
                            if (self.customerOrgInstance) {
                                self.customerOrgInstance.setSelected([]);
                            }
                            ApplicationAPI.getAssignedCustomerOrganizations(this.selectedApplicationId, 0, 200)
                                .then(result => {
                                    this.assignedCustomerOrgs = result.data.filter(item => item.status === 'SUCCESS').map(item => ({
                                        id: item.tenancyRef,
                                        name: item.tenancyRef
                                    }));
                                    console.log('Assigned Customer Organizations:', this.assignedCustomerOrgs);
                                    //this.modifiedAssignedCustomerOrgs = this.assignedCustomerOrgs.slice();
                                    this.assignedCustomerOrgs.forEach(item => {
                                        this.$set(this.checkboxState, item.id, true);
                                    });
                                    const assignedIds = this.assignedCustomerOrgs.map(c => c.id);
                                    this.unassignedCustomerOrgs = this.allCustomerOrgs.filter(c => !assignedIds.includes(c.id));
                                    console.log('Unassigned Customers:', this.unassignedCustomerOrgs);

                                    if (this.customerOrgInstance) {
                                        this.customerOrgInstance.setData(
                                            this.unassignedCustomerOrgs.map(org => ({ text: org.name, value: org.id }))
                                        );
                                    }
                                    self.selectedApplicationName = appName;                                   
                                    self.assignmentLoading = false;
                                    console.log('assignmentAction clicked', appName);

                                })
                        } catch (error) {
                            console.error('Error fetching customer orgs:', error);
                            self.$refs.AssignDrawer.close();
                            EventBus.$emit('error-notification', {
                                "msg": "Unable to fetch Assign Application data."
                            });
                        }
                    });
                });
            // View deployment button click
            this.$refs.applicationTable
                .querySelectorAll('td .view-deployment-btn')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        const deploymentId = e.target.getAttribute("data-id");
                        self.$router.push(self.CONTEXT_PATH + "/processengine/deployment/" + deploymentId);
                        console.log('deploymentAction clicked', deploymentId);
                    });
                });
            this.$refs.applicationTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(self.CONTEXT_PATH + "/design/applications/" + reference.trim());
                        }

                    });
                });
            $(".tagLabels").each((a, obj) => {
                let text1 = $(obj)
                    .text()
                    .split(",");
                let htmlTag = "";
                text1.forEach(b => {
                    if (b != "") {
                        htmlTag += '<span class="mcc-chip mcc-chip--soft-info mcc-chip--xs mu-mr-03">' + b + " </span>";
                    }
                });
                $(obj).html(htmlTag);
            });
        },
        onCustomerOrgChange(event) {
            this.selectedCustomerOrg = Array.from(event.target.selectedOptions).map(option => option.value);
        },
        initApplicationsTable() {
            let self = this;
            self.selectedApplications = [];
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#applicationTableId');
            this.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No applications found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        select: {
                            type: "boolean",
                            format: "checkbox",
                            title: "Select",
                            editable: true
                        },
                        name: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            columnSearch: false
                        },
                        labels: {
                            type: "string",
                            title: "Tags",
                            template: '<div class="tagLabels">{{labels}}</div>',
                            sortable: false,
                            columnSearch: false
                        },
                        prettyDeploymentTime: {
                            type: "string",
                            title: "Last deployed",
                            sortable: false,
                            template: '<div><u>{{prettyDeploymentTime}}</u><div>{{deploymentTime}}</div></div>',
                            columnSearch: false
                        },
                        disabled: {
                            type: "string",
                            title: "Disabled",
                            sortable: false,
                            columnSearch: false
                        },
                        protectedLabel: {
                            type: "string",
                            title: "Protected",
                            sortable: false,
                            columnSearch: false
                        },
                        editable: {
                            type: "string",
                            title: "Template",
                            sortable: false,
                            columnSearch: false
                        },
                        actions: {
                            type: "string",
                            title: "Actions",
                            template: function (row) {
                                let html = '<div>';
                                if (self.$store.getters.getSsoLicenseAdmin) {
                                    html += `<button class="mcc-button mcc-button--outline mcc-button--sm assign-btn" data-id="${row.id}" data-name="${row.name}" style="margin-right: 8px;">Assign</button>`;
                                }
                                if (
                                    self.$store.getters.getRoleAdmin && row.deploymentTime != null && row.deploymentTime !== ""
                                ) {
                                    html += `<button class="mcc-button mcc-button--outline mcc-button--sm view-deployment-btn" data-id="${row.deploymentId}" >View deployment</button>`;
                                }

                                html += '</div>';
                                return html;
                            },
                            sortable: false,
                            columnSearch: false
                        }

                    }
                },
                data: (start, limit, sortHeader, sortDirection, fullTextQuery, searchColumns) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        self.pageStart = start;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }

                        let disabledYes = self.disabledType == "yes" || self.disabledType == "all";
                        let disabledNo = self.disabledType == "no" || self.disabledType == "all";
                        let queryString = "start=" +

                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&name=" +
                            self.applicationName +
                            "&labelIds=" +
                            self.selectedLabels +
                            "&cYes=" +
                            disabledYes +
                            "&cNo=" +
                            disabledNo +
                            "&deployed=" +
                            self.deployedType +
                            "&isProtected=" +
                            self.protectedType;
                        let searchColumnsList = [];
                        return ApplicationAPI.getAppliations(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;

                            if (result.data != null) {
                                responseData.data = result.data;
                                // console.log(responseData.data);
                                responseData.data.forEach(function (obj, index) {
                                    obj.select = self.selectedApplications.indexOf(obj.id) != -1;
                                    obj["disabledCheckbox"] = obj.deleted != null;
                                    let actionsObj = {
                                        deploymentAction: {
                                            hidden: obj.deploymentTime == null,
                                            disabled: !self.$store.getters.getRoleAdmin
                                        }
                                    };

                                    obj["actions"] = actionsObj;
                                    obj.deploymentTime = obj.deploymentTime == null ? "" :
                                        Utils.getMomentDateString(obj.deploymentTime);
                                    obj.prettyDeploymentTime = obj.prettyDeploymentTime == null ? "" :
                                        obj.prettyDeploymentTime;

                                    let editableFlag;
                                    if (typeof obj.editable !== 'undefined') {
                                        editableFlag = obj.editable;
                                    } else if (typeof obj.canEdit !== 'undefined') {
                                        editableFlag = obj.canEdit;
                                    } else if (typeof obj.readOnly !== 'undefined') {
                                        // if backend exposes readOnly, invert it
                                        editableFlag = !obj.readOnly;
                                    } else {
                                        // default to true if unknown
                                        editableFlag = true;
                                    }
                                    obj.editable = editableFlag ? 'No' : 'Yes';
                                });
                            }
                            self.responseData = responseData.data;
                            self.tableData = responseData.data;
                            this.dataCall = false;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        this.dataCall = false;
                        return responseData;
                    }
                },
                onAction: (table, action, rowObj) => {
                    if (action == "select") {
                        rowObj.forEach((obj, a) => {
                            if (obj.value &&
                                self.selectedApplications.indexOf(obj.rowData.id) == -1) {
                                self.selectedApplications.push(obj.rowData.id);
                            } else if (!obj.value) {
                                self.selectedApplications.splice(self.selectedApplications.indexOf(obj.rowData.id), 1);
                            }
                        });
                    } else if (action == "deploymentAction") {
                        self.$router.push(self.CONTEXT_PATH +
                            "/processengine/deployment/" +
                            rowObj[0].rowData.deploymentId);
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.responseData.forEach((item, index) => {
                        if (item.disabledCheckbox) {
                            // self.tableObj.disableRowActions(self.pageStart + index);
                        }
                    });
                    self.updateCall = true;
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            // localStorage.setItem("applicationHomePageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem("DataTables_" + window.location.pathname + "_applicationName", this.applicationName);
            localStorage.setItem("DataTables_" + window.location.pathname + "_deployedType", this.deployedType);
            localStorage.setItem("DataTables_" + window.location.pathname + "_disabledType", this.disabledType);
            localStorage.setItem("DataTables_" + window.location.pathname + "_protectedType", this.protectedType);
            localStorage.setItem("DataTables_" + window.location.pathname + "_selectedLabels", this.selectedLabels);
            localStorage.setItem("applicationListFilterCount", this.filterCount);

        },
        exportApplications() {
            ImportExportAPI.exportFiles("APPLICATION", this.selectedApplications.toString());
        }
    },
};
</script>

<style scoped>
.spinner-overlay {
    position: absolute;
    top: 280px; 
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
}

.spinner-background {
    position: absolute;
    inset: -40px;
    background: rgba(255, 255, 255, 0.6);
}

.spinner-flex {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
